module.exports = __webpack_public_path__ + "img/ico_folder.039485d7.svg";